module.exports = __webpack_public_path__ + "img/camera-none.36c9cd27.jpg";